<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="idSituacaoConvenio != 9"
                >Adicionar
            </b-button>
        </b-button-group>
        <b-modal
            id="modalPrestacaoMensal"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Prestação de Conta Mensal -
                <b-badge variant="warning">NOVO</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtCompetencia">Competência</label>
                        <b-input-group>
                            <date-picker
                                id="dtCompetencia"
                                v-model="prestacaoMensal.dtCompetencia"
                                :config="$monthPickerOptions"
                                v-mask="'##/####'"
                                @input.native="$v.mesPrevisto.$touch()"
                            ></date-picker>
                            <b-form-invalid-feedback
                                >Competência é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtPrestacao">Data Prestação</label>
                        <b-input-group>
                            <date-picker
                                id="dtPrestacao"
                                v-model="prestacaoMensal.dtPrestacao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                            <b-form-invalid-feedback
                                >Data Prestação é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuTotalGasto">Total Despesas</label>
                        <b-input-group>
                            <money
                                id="nuTotalGasto"
                                v-model="prestacaoMensal.nuTotalGasto"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                                :disabled="true"
                            ></money>
                            <b-form-invalid-feedback
                                >Total Despesas é
                                obrigatória</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuTotalRendimentos"
                            >Total Rendimentos</label
                        >
                        <b-input-group>
                            <money
                                id="nuTotalRendimentos"
                                v-model="prestacaoMensal.nuTotalRendimentos"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Total Rendimentos é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuReceitasDiversas"
                            >Receitas Diversas</label
                        >
                        <b-input-group>
                            <money
                                id="nuReceitasDiversas"
                                v-model="prestacaoMensal.nuReceitasDiversas"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Receitas Diversas é
                                obrigatória</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="salvar()" class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConvenioServicos'

export default {
    props: {
        idConvenio: {
            type: Number
        },
        idSituacaoConvenio: {
            type: Number
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            prestacaoMensal: {
                idConvenio: 0,
                idPrestacaoContasMensal: 0,
                dtCompetencia: null,
                dtPrestacao: null,
                nuReceitasDiversas: 0,
                nuTotalGasto: 0,
                nuTotalRendimentos: 0,
                nuValorPendente: 0,
                valorConferido: 0,
                CodSituacao: 0,
                ValorGlosado: 0,
                Diferenca: 0,
                ValorRetencoes: 0
            }
        }
    },

    methods: {
        limpar() {
            this.prestacaoMensal.idConvenio = this.idConvenio
            this.prestacaoMensal.idPrestacaoContasMensal = 0
            this.prestacaoMensal.dtCompetencia = null
            this.prestacaoMensal.dtPrestacao = null
            this.prestacaoMensal.nuReceitasDiversas = 0
            this.prestacaoMensal.nuTotalGasto = 0
            this.prestacaoMensal.nuTotalRendimentos = 0
            this.prestacaoMensal.nuValorPendente = 0
            this.prestacaoMensal.valorConferido = 0
            this.prestacaoMensal.CodSituacao = 0
            this.prestacaoMensal.ValorGlosado = 0
            this.prestacaoMensal.Diferenca = 0
            this.prestacaoMensal.ValorRetencoes = 0
        },

        abrirModal() {
            this.mostrarModal = true
            this.limpar()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar() {
            this.prestacaoMensal.dtCompetencia =
                '01/' + this.prestacaoMensal.dtCompetencia
            this.prestacaoMensal.dtCompetencia = this.$moment(
                this.prestacaoMensal.dtCompetencia,
                'DD/MM/YYYY'
            ).format('YYYY-MM-DD')
            this.prestacaoMensal.dtPrestacao = this.$moment(
                this.prestacaoMensal.dtPrestacao,
                'DD/MM/YYYY'
            ).format('YYYY-MM-DD')

            this.$store.dispatch('addRequest')
            ConveniosServicos.InserirPrestacaoMensal(this.prestacaoMensal).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.fecharModal()
                            this.$emit('atualizarLista')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    }
}
</script>
